// // src/pwa/utils/device.JS
// export function detectDevice() {
//   const ua = navigator.userAgent || '';
//   const isAndroid = /Android/i.test(ua);
//   // iPadOS: UAに iPad がないケース(macOSを名乗る)に対応
//   const looksLikeIpad =
//     /iPad/i.test(ua) || ((/Macintosh/i.test(ua) || navigator.platform === 'MacIntel') && navigator.maxTouchPoints > 1);
//   const isIphone = /iPhone/i.test(ua) && !looksLikeIpad;
//   const isIpad = looksLikeIpad;
//   return { isIphone, isIpad, isAndroid };
// }

// export function isPwaSupportedIphoneOnly() {
//   const { isIphone, isIpad, isAndroid } = detectDevice();
//   return isIphone && !isIpad && !isAndroid;
// }

// src/pwa/utils/device.js
export function detectDevice() {
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);

  // iPadOS: UA が Macintosh でもタッチがあれば iPad とみなす
  const looksLikeIpad =
    /iPad/i.test(ua) ||
    ((/Macintosh/i.test(ua) || navigator.platform === 'MacIntel') &&
      navigator.maxTouchPoints > 1);

  return {
    isAndroid,
    isIphone: /iPhone/i.test(ua) && !looksLikeIpad,
    isIpad: looksLikeIpad,
  };
}

// PWA(インストール版) で起動しているかどうか
export function isStandalone() {
  // iOS Safari は navigator.standalone、他は display-mode: standalone
  const dm = window.matchMedia?.('(display-mode: standalone)');
  return !!(navigator.standalone || (dm && dm.matches));
}

// Web Push の基本要件（HTTPS / SW / Push / Notification）
export function hasWebPushBasics() {
  return (
    typeof window !== 'undefined' &&
    (window.isSecureContext || ['localhost', '127.0.0.1'].includes(window.location.hostname)) &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

/**
 * Web Push を許可する端末・形態
 * - iPhone / iPad: インストール済み PWA(standalone) のみ
 * - Android      : インストール済み PWA(standalone) のみ  ← ブラウザは除外
 * - PC 等        : ここでは除外したいなら false を返す
 */
export function isWebPushAllowedHere() {
  if (!hasWebPushBasics()) return false;

  const { isAndroid, isIphone, isIpad } = detectDevice();

  // どの端末でも “standalone” でなければ不可
  if (!isStandalone()) return false;

  // iOS / iPadOS / Android の PWA は許可
  if (isAndroid || isIphone || isIpad) return true;

  // デスクトップを許可したくない場合は false を返す
  return false;
}